import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Chart, DoughnutController} from 'chart.js';
import {TruckFormService} from '../../services/truck-form/truck-form.service';
import Tco from '../../models/tco';

// Chart.register(DoughnutController);

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements AfterViewInit {

  constructor(private _truckFormService: TruckFormService) {
  }

  ngAfterViewInit(): void {
    if (this._truckFormService.dieselTCO === null || this._truckFormService.electricTCO === null ||
      this._truckFormService.hydrogenTCO === null) {
      return;
    }

    this.generateTCOComparisonChart(this._truckFormService.dieselTCO, this._truckFormService.electricTCO,
      this._truckFormService.hydrogenTCO);

  }

  // ngOnInit(): void {
  //
  // this.generateTCOComparisonChart(this._truckFormService.dieselTCO, this._truckFormService.electricTCO,
  //   this._truckFormService.hydrogenTCO);
  // this.generateTCOChart('diesel-tco-chart', this._truckFormService.dieselTCO);
  // this.generateTCOChart('electric-tco-chart', this._truckFormService.electricTCO);
  // this.generateTCOChart('hydrogen-tco-chart', this._truckFormService.hydrogenTCO);
  // }


  get truckFormService(): TruckFormService {
    return this._truckFormService;
  }

  private tcoValuesDefined(dieselTCO: Tco | null, electricTCO: Tco | null, hydrogenTCO: Tco | null): boolean {
    return dieselTCO !== null && electricTCO !== null && hydrogenTCO !== null;
  }

  private generateTCOComparisonChart(dieselTCO: Tco, electricTCO: Tco, hydrogenTCO: Tco): Chart {
    return new Chart('tco-comparison-chart', {
      type: 'bar',
      data: {
        labels: ['Camión Diesel', 'Camión Eléctrico', 'Camión Hidrógeno'],
        datasets: [
          {
            label: 'Precio Vehículo',
            data: [dieselTCO.vehiclePrice, electricTCO.vehiclePrice, hydrogenTCO.vehiclePrice],
            backgroundColor: 'rgb(255, 0, 0)'
          },
          {
            label: 'Combustible',
            data: [dieselTCO.fuel, electricTCO.fuel, electricTCO.fuel],
            backgroundColor: 'rgb(54, 162, 235)'
          },
          {
            label: 'Mantenimiento',
            data: [dieselTCO.maintenance, electricTCO.maintenance, hydrogenTCO.maintenance],
            backgroundColor: 'rgb(0, 255, 0)'
          },
          {
            label: 'Batería Extra',
            data: [dieselTCO.batteryResidualValue, electricTCO.batteryResidualValue, hydrogenTCO.batteryResidualValue],
            backgroundColor: 'rgb(23, 123, 79)'
          },
          {
            label: 'Seguro',
            data: [dieselTCO.insurance, electricTCO.insurance, hydrogenTCO.insurance],
            backgroundColor: 'rgb(255,255,0)'
          },
          {
            label: 'Patente',
            data: [dieselTCO.patent, electricTCO.patent, hydrogenTCO.patent],
            backgroundColor: '#add8e6'
          },
          {
            label: 'Infraestructura',
            data: [dieselTCO.infrastructure, electricTCO.infrastructure, hydrogenTCO.infrastructure],
            backgroundColor: 'rgb(128,128,128)'
          }
        ]
      },
      options: {
        indexAxis: 'y',
        plugins: {
          title: {
            display: true,
            text: 'Comparativa TCO'
          }
        },
        responsive: true,
        scales: {
          x: {
            stacked: true
          },
          y: {
            beginAtZero: true,
            stacked: true
          }
        }
      },
    });
  }

  // private generateTCOChart(chartId: string, tco: Tco): Chart {
  //   return new Chart(chartId, {
  //     type: 'doughnut',
  //     data: {
  //       labels: ['Precio', 'Combustible', 'Mantenimiento', 'Batería extra', 'Seguro', 'Patente', 'Infraestructura'],
  //       datasets: [
  //         {
  //           label: 'Test',
  //           data: [tco.vehiclePrice, tco.fuel, tco.maintenance, tco.extraBattery, tco.insurance, tco.patent, tco.infrastructure],
  //           backgroundColor: [
  //             'rgb(255, 0, 0)',
  //             'rgb(0, 255, 0)',
  //             'rgb(0, 0, 255)',
  //             'rgb(255, 0, 255)',
  //             'rgb(255, 255, 0)',
  //             'rgb(0, 255, 255)',
  //             '#eee'
  //           ]
  //         }
  //       ]
  //     }
  //
  //   });
  // }

}
